import React, { Children } from 'react';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
import { CustomCursor } from './CustomCursor';
import { AnimatedSection } from './AnimatedSection';
interface LayoutProps {
  children: ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col relative" data-id="element-57">
      <ScrollToTop data-id="element-58" />

      <CustomCursor data-id="element-59" />
      <Navigation data-id="element-60" />
      <main className="flex-grow relative z-10" data-id="element-61">{children}</main>
      {/* Image Strip — Before Footer */}
      <div className="relative z-10" data-id="element-62">
        <AnimatedSection data-id="element-63">
          <div className="grid grid-cols-1 md:grid-cols-3" data-id="element-64">
            <div className="overflow-hidden" data-id="element-65">
              <img src="https://cdn.magicpatterns.com/uploads/svuqCvjzYKpdsqKhxyHAry/DSCN3897.jpg" alt="Children smiling in a Southeast Asian community" className="w-full h-64 md:h-80 object-cover" data-id="element-66" />
            </div>
            <div className="overflow-hidden" data-id="element-67">
              <img src="https://cdn.magicpatterns.com/uploads/oycjRBLuBGVUMSr6Xgqnpb/FromTerri_Cambodia2.jpg" alt="Lush green waterway in Cambodia" className="w-full h-64 md:h-80 object-cover" data-id="element-68" />
            </div>
            <div className="overflow-hidden" data-id="element-69">
              <img src="https://cdn.magicpatterns.com/uploads/mkZE6qihPVdec631fiWWkN/FromTerri_Cambodia6.jpg" alt="Rice fields in Cambodia" className="w-full h-64 md:h-80 object-cover" data-id="element-70" />
            </div>
          </div>
        </AnimatedSection>
      </div>
      <Footer data-id="element-71" />
    </div>;
}